import { createButtonListSetters } from '@/common/manager/button';
import { ButtonPosition } from '@/common/manager/position/button-position';

export default function (config) {
  const { isInChildTable } = config || {};
  const additionalPosition =
    isInChildTable === true ? ButtonPosition.childTableOperate : undefined;
  return {
    name: 'buttons',
    title: '操作列（按钮超过三个会自动收到更多里）',
    display: 'accordion',
    // collapsed:false,
    initialValue: [
      {
        children: '按钮',
        primaryKey: '123',
      },
    ],
    // supportVariable: true,
    setter: createButtonListSetters({
      position: ButtonPosition.tableOperate,
      childrenTitle: '操作文案',
      additionalPosition,
    }),
  };
}
